import React, { useEffect, useRef, useState } from 'react';
import { DndContext, KeyboardSensor, PointerSensor, closestCenter, useSensor, useSensors, } from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import { ButtonClean, Icon } from '@fourthwall/components';
import { PencilIcon } from '@fourthwall/icons';
import { EditableSettingsItem } from './EditableSettingsItem';
import { InlineSettingEditor } from './InlineSettingEditor';
import * as S from './SettingsTab.styled';
const SortableSettingsItem = ({ setting, onEdit, onDelete }) => {
    return React.createElement(EditableSettingsItem, { setting: setting, onEdit: onEdit, onDelete: onDelete });
};
export const SettingsTab = ({ settings, onSettingsChange }) => {
    const [showInlineEditor, setShowInlineEditor] = useState(false);
    const inlineEditorRef = useRef(null);
    const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
    }));
    const handleAddSetting = () => {
        setShowInlineEditor(true);
    };
    // Scroll to the inline editor when it becomes visible
    useEffect(() => {
        if (showInlineEditor && inlineEditorRef.current) {
            inlineEditorRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    }, [showInlineEditor]);
    const handleEditSetting = (setting) => {
        const updatedSettings = settings.map((s) => (s.id === setting.id ? setting : s));
        onSettingsChange(updatedSettings);
    };
    const handleDeleteSetting = (settingId) => {
        const updatedSettings = settings.filter((s) => s.id !== settingId);
        onSettingsChange(updatedSettings);
    };
    const handleSaveSetting = (setting) => {
        // Add new setting
        onSettingsChange([...settings, setting]);
        setShowInlineEditor(false);
    };
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active.id !== over?.id) {
            const oldIndex = settings.findIndex((s) => s.id === active.id);
            const newIndex = settings.findIndex((s) => s.id === over?.id);
            if (oldIndex !== -1 && newIndex !== -1) {
                const updatedSettings = [...settings];
                const [movedSetting] = updatedSettings.splice(oldIndex, 1);
                updatedSettings.splice(newIndex, 0, movedSetting);
                onSettingsChange(updatedSettings);
            }
        }
    };
    return (React.createElement("div", null,
        React.createElement(S.SettingsSection, null,
            settings.length > 0 || showInlineEditor ? (React.createElement(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd },
                React.createElement(SortableContext, { items: settings.map((s) => s.id), strategy: verticalListSortingStrategy },
                    React.createElement(S.SettingsList, null, settings.map((setting) => (React.createElement(SortableSettingsItem, { key: setting.id, setting: setting, onEdit: handleEditSetting, onDelete: handleDeleteSetting }))))))) : (React.createElement(S.EmptySettings, null,
                React.createElement(S.EmptySettingsText, null, "No settings configured"),
                React.createElement(S.EmptySettingsSubtext, null,
                    React.createElement(ButtonClean, { label: "Add Settings", appearance: "primary", onClick: handleAddSetting })))),
            showInlineEditor && (React.createElement(S.InlineEditorContainer, { ref: inlineEditorRef },
                React.createElement(InlineSettingEditor, { icon: React.createElement(Icon, { component: PencilIcon, height: 12 }), header: React.createElement(S.SettingInfo, null,
                        React.createElement(S.SettingType, null, "New Setting"),
                        React.createElement(S.SettingName, null, "New Setting")), onClose: () => setShowInlineEditor(false), onSave: handleSaveSetting, create: true })))),
        settings.length > 0 && !showInlineEditor && (React.createElement(S.AddButtonContainer, null,
            React.createElement(ButtonClean, { label: "Add Setting", appearance: "primary", onClick: handleAddSetting })))));
};
